import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const guides = [
  {
    group: '🏠 대시보드',
    items: [
      {
        title: '대시보드',
        desc: '셀러랭키의 시작 화면입니다. 등록한 쇼핑 상품과 플레이스의 순위 현황, 맞춤 마케팅 플랜 진행 상태를 한눈에 확인할 수 있습니다.',
        badge: '',
      }
    ]
  },
  {
    group: '📊 데이터 분석',
    items: [
      {
        title: '키워드 검색량 (다중)',
        desc: '최대 50개의 키워드를 한 번에 입력하면 네이버에서 해당 키워드가 한 달에 얼마나 검색되는지 확인할 수 있습니다. 어떤 키워드가 더 많이 검색되는지 비교해서 상품명이나 광고 키워드 전략을 세울 때 유용합니다.',
        badge: '',
      },
      {
        title: '키워드 검색량 (연관)',
        desc: '하나의 키워드를 입력하면 연관된 키워드들과 각각의 검색량을 함께 보여줍니다. 내가 미처 생각하지 못한 키워드를 발굴하거나 더 많이 검색되는 유사 키워드를 찾을 때 활용하세요.',
        badge: '',
      },
      {
        title: '형태소 분석기',
        desc: '텍스트를 붙여넣으면 자주 등장하는 단어를 추출해서 빈도순으로 정리합니다. 네이버 블로그나 카페 글을 작성할 때 어떤 단어를 얼마나 자연스럽게 포함시켜야 하는지 파악하는 데 유용합니다. 상위 노출된 경쟁사 블로그 글이나 카페 게시물을 분석해서 자주 쓰이는 핵심 단어를 파악하고, 내 바이럴 콘텐츠 작성 시 전략적으로 활용하면 네이버 검색 상위 노출에 도움이 됩니다.',
        badge: '',
      },
    ]
  },
  {
    group: '🛒 온라인 데이터',
    items: [
      {
        title: '쇼핑 순위 조회',
        desc: '내 스마트스토어 상품이 네이버 쇼핑에서 특정 키워드로 검색했을 때 몇 위에 노출되는지 확인합니다. 상품 URL과 확인하고 싶은 키워드를 입력하면 현재 순위를 바로 알 수 있습니다.',
        badge: '',
      },
      {
        title: '순위 변동 추적',
        desc: '등록한 상품의 키워드별 순위가 날마다 어떻게 변하는지 그래프로 확인할 수 있습니다. 매일 새벽 4시에 자동으로 순위를 기록하며, 매일 오전 등록된 이메일(아이디)로 전날 대비 순위 변동 사항을 알려드립니다. 순위가 갑자기 떨어졌을 때 빠르게 파악하고 대응할 수 있습니다. 추후 카카오톡 알림 서비스도 제공할 예정입니다.',
        badge: 'Basic 이상',
        highlight: '이메일(아이디)',
      },
      {
        title: '통합검색 분석 (다중)',
        desc: '여러 키워드를 입력하면 네이버 통합검색 결과에서 카페, 지식인, 블로그에 어떤 URL들이 노출되는지 수집합니다. 어떤 채널이 상위에 노출되고 있는지 파악할 수 있어 바이럴 마케팅 작업을 계획하고 실행할 때 큰 도움이 됩니다. 경쟁사가 어떤 채널을 통해 노출되고 있는지도 한눈에 확인할 수 있습니다.',
        badge: '',
      },
      {
        title: '통합검색 분석 (수집)',
        desc: '하나의 키워드로 카페, 지식인, 블로그 상위 노출 URL을 한 번에 수집합니다. 내 콘텐츠가 상위에 노출되고 있는지, 경쟁사 콘텐츠가 얼마나 많은지 확인할 수 있습니다.',
        badge: '',
      },
      {
        title: '경쟁사 비교 (개발 예정)',
        desc: '경쟁사 상품 URL을 입력하면 내 상품과의 차이점을 분석합니다. 가격, 리뷰 수, 상품 구성, 키워드 전략 등을 비교해서 내 상품의 부족한 부분을 파악하고 보완할 수 있습니다. 네이버 쇼핑 순위를 올리고 구매 전환율을 높이기 위한 구체적인 개선 방향을 찾는 데 활용하세요.',
        badge: '개발 예정',
      },
    ]
  },
  {
    group: '📍 플레이스 데이터',
    items: [
      {
        title: '플레이스 순위 조회',
        desc: '내 네이버 플레이스(가게)가 특정 키워드로 검색했을 때 몇 위에 노출되는지 확인합니다. 플레이스 URL과 키워드를 입력하면 현재 순위와 주변 경쟁 업체 목록을 함께 볼 수 있습니다.',
        badge: '',
      },
      {
        title: '순위 변동 추적',
        desc: '플레이스 순위가 날마다 어떻게 변하는지 추적합니다. 매일 새벽 4시 30분에 자동 기록되며, 매일 오전 등록된 이메일(아이디)로 순위 변동 사항을 알려드립니다. 마케팅 활동 후 순위가 실제로 오르고 있는지 확인하는 데 유용합니다. 추후 카카오톡 알림 서비스도 제공할 예정입니다.',
        badge: 'Basic 이상',
        highlight: '이메일(아이디)',
      },
      {
        title: '경쟁사 분석',
        desc: '경쟁 업체의 플레이스 URL을 입력하면 메뉴, 소식, 사진 등 주요 정보를 수집해서 우리 가게와 비교할 수 있습니다.',
        badge: '',
      },
      {
        title: '경쟁사 비교',
        desc: '네이버 플레이스 순위는 크게 두 가지 점수로 결정됩니다.\n\nN1 관련도 점수 - 검색어와 얼마나 관련 있는 매장인가\n상호명, 카테고리, 소개글, 메뉴명, 찾아오는 길 등 플레이스에 직접 입력한 텍스트가 검색어와 얼마나 일치하는지를 평가합니다. 소개글을 작성하지 않거나 메뉴를 등록하지 않으면 검색 노출에서 불리해집니다. 경쟁사가 어떤 텍스트를 어떻게 채워두고 있는지 비교해서 내 플레이스에서 빠진 항목이 무엇인지 바로 파악할 수 있습니다.\n\nN2 행동 데이터 점수 - 고객이 얼마나 반응하는 매장인가\n방문자 리뷰 수, 블로그 리뷰 수, 평점, 네이버 예약 연결, 주문/배달 연결, 네이버페이 연결 등 실제 고객 행동 데이터를 평가합니다. 경쟁사와 항목별로 직접 비교해서 리뷰가 얼마나 차이 나는지, 예약이나 주문 기능이 연결되어 있는지 등 지금 당장 개선할 수 있는 항목을 파악할 수 있습니다.\n\n단순한 숫자 비교를 넘어 "왜 경쟁사가 나보다 상위에 노출되는가"를 항목별로 분석해서 구체적인 개선 방향을 제시합니다. 셀러랭키의 가장 강력한 기능 중 하나입니다.',
        badge: '',
      },
    ]
  },
  {
    group: '✨ 맞춤 마케팅 플랜',
    items: [
      {
        title: 'Step 1. 관여도 진단',
        desc: '마케팅 전략의 출발점은 "내 상품이 어떤 종류의 상품인가"를 정확히 파악하는 것입니다.\n\n저관여 상품이란 소비자가 크게 고민하지 않고 충동적으로 구매하는 상품입니다. 예) 소모품, 간식, 저가 생활용품. 이런 상품은 눈에 잘 띄게 노출시키고 즉각적인 구매를 유도하는 전략이 효과적입니다.\n\n고관여 상품이란 소비자가 여러 번 비교하고 신중하게 구매를 결정하는 상품입니다. 예) 가전제품, 건강식품, 고가 패션. 이런 상품은 신뢰를 쌓고 정보를 충분히 제공하는 전략이 필요합니다.\n\n많은 판매자들이 이 구분 없이 마케팅을 진행하다 보니 효과가 없다고 느끼는 경우가 많습니다. Step 1에서 내 상품의 관여도를 정확히 진단하면, 이후 Step 2~4의 전략이 훨씬 구체적이고 실효성 있게 만들어집니다.',
        badge: '',
      },
      {
        title: 'Step 2. 마케팅 전략',
        desc: 'Step 1 진단 결과를 바탕으로 4가지 핵심 전략을 자동으로 생성합니다.\n\n채널 전략: 블로그, 카페, 인스타그램, 유튜브 중 어떤 채널에 집중해야 하는지\n바이럴 전략: 어떤 방식으로 입소문을 만들어야 하는지\n리뷰 전략: 구매 후기를 어떻게 관리하고 활용할지\n예산 배분: 광고비를 어떻게 나눠서 사용할지\n\n스마트스토어와 플레이스 각각에 맞는 전략을 따로 제공하므로 두 채널을 동시에 운영하는 판매자에게 특히 유용합니다.',
        badge: '',
      },
      {
        title: 'Step 3. 키워드 전략',
        desc: '마케팅에서 키워드는 고객이 나를 찾는 통로입니다. 검색량이 너무 많은 키워드는 경쟁이 치열하고, 너무 적은 키워드는 노출이 안 됩니다.\n\nStep 3에서는 내 상품에 맞는 메인 키워드와 서브 키워드를 추천하고, 각 키워드의 적합도를 1~10점으로 평가합니다. 검색량, 경쟁 강도, 상품 연관성을 종합해서 지금 당장 공략 가능한 키워드를 골라드립니다. 원하지 않는 키워드는 제외하고 새로운 키워드를 추가해서 내 상황에 맞게 조정할 수 있습니다.',
        badge: '',
      },
      {
        title: 'Step 4. 전략 리포트',
        desc: 'Step 1~3의 모든 분석 결과를 하나의 리포트로 종합합니다.\n\n• 내 상품의 관여도 진단 요약\n• 채널별 마케팅 전략 요약\n• 공략 키워드 목록\n• 핵심 전략 TOP 5: 지금 당장 실행해야 할 가장 중요한 5가지 액션\n• 4주 액션 플랜: 1주차부터 4주차까지 주차별로 무엇을 해야 하는지 구체적인 실행 계획\n\nPDF로 저장해서 직원, 마케팅 대행사, 파트너와 공유할 수 있습니다.',
        badge: 'Basic 이상',
        highlight: 'PDF 저장',
      },
    ]
  },
];

const BADGE_COLOR: Record<string, { bg: string; color: string }> = {
  'Basic 이상': { bg: '#0F2A22', color: '#00D4AA' },
  '개발 예정': { bg: '#1A1500', color: '#F6AD55' },
};

export default function Guide() {
  const navigate = useNavigate();
  const [activeGroup, setActiveGroup] = useState(guides[0].group);
  const activeGuide = guides.find(g => g.group === activeGroup);

  const isLoggedIn = !!(localStorage.getItem('token') || sessionStorage.getItem('token'));
  const s: any = {
    wrap: { maxWidth: 800 },
    groupBtn: (active: boolean) => ({
      background: active ? '#1A2035' : 'none',
      border: active ? '0.5px solid #00D4AA' : '0.5px solid #2A3045',
      borderRadius: 8, padding: '8px 16px',
      color: active ? '#00D4AA' : '#8892A4',
      fontSize: 13, cursor: 'pointer', fontWeight: active ? 700 : 400,
      whiteSpace: 'nowrap' as const,
    }),
    card: {
      background: '#161B27', border: '0.5px solid #2A3045',
      borderRadius: 12, padding: 24, marginBottom: 12,
    },
    badge: (type: string) => ({
      display: 'inline-block',
      background: BADGE_COLOR[type]?.bg || '#1A2035',
      color: BADGE_COLOR[type]?.color || '#8892A4',
      fontSize: 11, fontWeight: 700,
      padding: '2px 10px', borderRadius: 99, marginLeft: 8,
    }),
  };

  const renderDesc = (desc: string, highlight?: string) => {
    const parts = desc.split('\n\n');
    return parts.map((para, i) => {
      if (highlight && para.includes(highlight)) {
        const idx = para.indexOf(highlight);
        return (
          <p key={i} style={{ color: '#8892A4', fontSize: 14, lineHeight: 1.8, margin: '0 0 12px' }}>
            {para.slice(0, idx)}
            <strong style={{ color: '#00D4AA', background: '#0F2A22', padding: '1px 6px', borderRadius: 4 }}>{highlight}</strong>
            {para.slice(idx + highlight.length)}
          </p>
        );
      }
      return (
        <p key={i} style={{ color: '#8892A4', fontSize: 14, lineHeight: 1.8, margin: '0 0 12px' }}>
          {para}
        </p>
      );
    });
  };

  return (
    <Layout>
      <div style={s.wrap}>
        <div style={{ marginBottom: 24 }}>
          <h2 style={{ color: '#E8ECF4', fontSize: 20, fontWeight: 800, marginBottom: 4 }}>📖 사용 가이드</h2>
          <p style={{ color: '#8892A4', fontSize: 13, margin: 0 }}>셀러랭키의 모든 기능을 소개합니다</p>
        </div>

        {/* 그룹 탭 */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 24, overflowX: 'auto', paddingBottom: 4 }}>
          {guides.map(g => (
            <button key={g.group} style={s.groupBtn(activeGroup === g.group)} onClick={() => setActiveGroup(g.group)}>
              {g.group}
            </button>
          ))}
        </div>

        {/* 기능 카드 */}
        {activeGuide?.items.map(item => (
          <div key={item.title} style={s.card}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
              <span style={{ color: '#E8ECF4', fontSize: 15, fontWeight: 700 }}>{item.title}</span>
              {item.badge && <span style={s.badge(item.badge)}>{item.badge}</span>}
            </div>
            {renderDesc(item.desc, item.highlight)}
          </div>
        ))}

        {/* 하단 CTA - 비로그인만 표시 */}
        {!isLoggedIn &&
        <div style={{ background: 'linear-gradient(135deg, #0F2A22, #0D1F35)', border: '0.5px solid #00D4AA33', borderRadius: 12, padding: 24, marginTop: 8, textAlign: 'center' as const }}>
          <div style={{ color: '#E8ECF4', fontSize: 15, fontWeight: 700, marginBottom: 8 }}>지금 바로 시작해보세요</div>
          <p style={{ color: '#8892A4', fontSize: 13, marginBottom: 16 }}>모든 기능을 무료로 체험할 수 있습니다</p>
          <button onClick={() => navigate('/register')} style={{ background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 32px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            무료 회원가입
          </button>
        </div>}
      </div>
    </Layout>
  );
}
